module.exports = __webpack_public_path__ + "cff1bf3e958545abc67b6f2baa36aeb9.MP3";